import React, { useCallback, useEffect, useRef, useState } from 'react';

import GemOverlay from './GemOverlay';

const REQUIRED_CLICKS = 5;
// Reset the click streak if the user pauses too long between clicks.
const RESET_MS = 2000;

export default function Gem() {
  const [open, setOpen] = useState(false);
  const clicks = useRef(0);
  const timer = useRef<ReturnType<typeof setTimeout>>(undefined);

  useEffect(() => () => clearTimeout(timer.current), []);

  const handleClick = useCallback(() => {
    clearTimeout(timer.current);
    clicks.current += 1;
    if (clicks.current >= REQUIRED_CLICKS) {
      clicks.current = 0;
      setOpen(true);
      return;
    }
    timer.current = setTimeout(() => {
      clicks.current = 0;
    }, RESET_MS);
  }, []);

  return (
    <>
      <div
        onClick={handleClick}
        aria-hidden='true'
        style={{
          position: 'fixed',
          right: 0,
          bottom: 0,
          width: 48,
          height: 48,
          zIndex: 1500,
        }}
      />
      {open && <GemOverlay onClose={() => setOpen(false)} />}
    </>
  );
}
